import styled from 'styled-components'

import {
  ReactComponent as CPF
} from '../../assets/icons/cpf-person-icon.svg'
import {
  ReactComponent as Certified
} from '../../assets/icons/certified-icon.svg'
import {
  ReactComponent as FileUpload
} from '../../assets/icons/file-upload-icon.svg'
import {
  ReactComponent as CreditCard
} from '../../assets/icons/credit-card-icon.svg'

export const Container = styled.div``

export const Subheader = styled.div`
  height: 126px;
  width: 100%;

  position: relative;

  background: var(--blue00);
  background: linear-gradient(90deg, rgba(0,105,182,1) 0%, rgba(0,120,208,1) 10%);

  .personal-profile__subheader-button{
    width: fit-content;
    height: 20px;

    position: absolute;
    top: calc(50% - 10px);
    left: 222.1px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;
    transition: filter 0.3s;

    &:hover{
      filter: brightness(1.1);
    }
  }

  .personal-profile__subheader-icon{
    height: 20px;
    width: auto;
    stroke: #fff;
  }

  @media (max-width: 1170px){
    .personal-profile__subheader-button{
      top: calc(30% - 10px);
      left: 20px;
    }
  }
`

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 0 0 45.4px;

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
    padding: 0 0 100px;
  }
`

export const Section = styled.section`
  width: 100%;
  height: fit-content;
  margin-top: -93px;

  display: flex;
  flex-direction: column;
  align-items: center;

  .pro-profile__section__title{
    margin-top: 15px;

    font-size: 2rem;
    color: var(--blue00);
  }

  .pro-profile__section__form{
    width: 98%;
    max-width: 456.87px;
    height: fit-content;
    padding: 46.8px 0 43.1px;
    margin-top: 30.2px;

    background-color: var(--bluef0);
    border-radius: 29px;
  }

  .pro-profile__section__form-wrapper{
    width: 85%;
    height: fit-content;
    margin: 0 auto;

    display: flex;
    flex-direction: column;
  }

  .pro-profile__section__form-label{
    font-size: 1.3125rem;
    color: var(--blue00);

    &:not(:first-child){
      margin-top: 42.4px;
    }
  }

  .pro-profile__section__account-input,
  .pro-profile__section__form-input,
  .pro-profile__section__form-icon-input{
    height: 55.58px;
    padding: 0 21.9px;

    color: var(--blue00);
    font-size: 0.9375rem;
    border-radius: 19px;
    border: 0;
    outline: none;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
  }

  .pro-profile__section__form-input{
    width: 100%;
    margin-top: 10.4px;
  }

  .pro-profile__section__form-icon-input{
    width: 100%;
    margin-top: 10.4px;
    padding: 0px;

    background-color: #fff;
  }

  .pro-profile__section__form-certificate-button{
    width: 100%;
    max-width: fit-content;
    margin-top: 24.3px;

    display: block;

    text-align: left;
    border: 0;
    outline: none;
    background-color: transparent;
    cursor: pointer;
  }

  .pro-profile__section__form-certificate-small{
    margin-left: 5.5px;

    font-size: 1.0625rem;
    font-weight: lighter;
    color: var(--blue00);
    vertical-align: bottom;
  }

  .pro-profile__section__form-select{
    margin-top: 10.4px;
  }

  .pro-profile__section__account-wrapper{
    height: 55.58px;
    margin: 24.1px 0;

    display: flex;
    gap: 17.1px;
  }

  .pro-profile__section__account-select{
    width: 60%;
    height: 100%;
  }

  .pro-profile__section__account-input{
    width: 40%;
    height: 100%;
  }

  .pro-profile__section__submit-button{
    width: 100%;
    max-width: 358.32px;
    height: 57.04px;
    margin: 37px auto 0;

    border-radius: 29px;
    font-size: 1.3125rem;
    text-align: center;
    color: #fff;
    border: 0;
    outline: none;
    background-color: var(--blue00);
    cursor: pointer;
  }
`

export const CPFIcon = styled(CPF)`

`

export const FileUploadIcon = styled(FileUpload)`
  width: 16.46px;
  height: 23.23px;

  fill: var(--blue00);
  stroke: var(--blue00);
  vertical-align: bottom;
`

export const CertifiedIcon = styled(Certified)`
  width:  41.69px;
  height: 40.09px;

  fill: var(--grayad);
`

export const CreditCardIcon = styled(CreditCard)`
  width: 32.47px;
  height: 25.51px;
  margin-right: 12px;

  fill: var(--grayad);
`
